import output from "_src/engine/output.js";
import primitiveFactory from "_src/engine/factories/primitive";
import objFactory from "_src/engine/factories/object";
import bufferFactory from "_src/engine/factories/pixel_buffer";
import {
  primitiveType,
  pixelBufferType,
  textureMinFilter,
  textureMagFilter
} from "_src/engine/constants";

import loader from "_src/loader";

import { quat } from "_src/libs/gl-matrix";
import {screenUtils} from "_src/client/utils";

import pngFont from "_assets/fonts/Roboto-BlackItalic.png";
import jsonFont from "_assets/fonts/Roboto-BlackItalic.jsonf";

const VIRTUAL_HEIGHT = 20;
const COLOR = [0.0, 0.0, 0.0];

let _texture = null;
let _descriptor = null;

export default {

  async init() {
    let minFilter = textureMinFilter.NEAREST;
    let magFilter = textureMagFilter.NEAREST;

    const filtering = false;

    if (filtering) {
      minFilter = textureMinFilter.LINEAR;
      magFilter = textureMagFilter.LINEAR;
    }

    const image = await loader.load(pngFont, loader.IMAGE);
    const json = await loader.load(jsonFont, loader.JSON);

    if (!image || !json) {
      output.error(output.DEVELOPERS_ERROR, "Couldn't load font data.");
      return;
    }

    _texture = bufferFactory.create(pixelBufferType.T_RGBA, {width: image.width, height: image.height,
        minFilter, magFilter, flipY: true });
    _texture.initMipMapLevelImage(0, image);

    _descriptor = json;
  },

  create(text, shader) {
    const backfaceRotation = quat.create();
    quat.rotateY(backfaceRotation, backfaceRotation, Math.PI);

    const textDrawable = objFactory.createDrawable(shader);
    const plane1 = createTextPlane(_texture, shader, text);
    const plane2 = createTextPlane(_texture, shader, text);

    textDrawable.add(plane1);
    textDrawable.add(plane2);
    plane2.rotate(backfaceRotation);

    return textDrawable;
  },

  updateScreenAppearance(widget, camera, flip) {
    const textWorldMatrix = widget.getChildren()[0].modelMatrix;
    const textWorldPosition = [textWorldMatrix[12], textWorldMatrix[13], textWorldMatrix[14]];

    const scale = screenUtils.calculateObjectScale(VIRTUAL_HEIGHT, 1.0, textWorldPosition, camera);
    const yScale = flip ? scale : -scale;
    for (const child of widget.getChildren()) {
      child.setScale(scale, yScale, scale);
    }

  },

  setVisibility(widget, visible) {
    for (const child of widget.getChildren()) {
      child.setVisibility(visible);
    }
  },

  cleanup() {
    _texture = null;
  }

}


function createTextPlane(texture, shader, text) {
  const mesh = objFactory.createDrawable(shader);
  const geometry = primitiveFactory.create(primitiveType.TEXT_PLANE, {text: text,
    fontDescriptor: _descriptor["glyphs"], textureWidth: _texture.width, yStart: 0.25});
  mesh.addGeometryChunk(geometry);

  mesh.setDiffuseColor(...COLOR);
  mesh.setTexture(texture, 0);
  mesh.setFrustrumCulling(false);

  return mesh;
}
